module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Bi-wekly-ritual-Web-1280.09a0b50b.jpg";